export default __webpack_public_path__ + "static/media/Panjeree-2.8cc1cc5e.gif";